import { Pipe, PipeTransform } from '@angular/core';
import { DomUtils } from 'app/shared/utils/dom.utils';

@Pipe({
    name: 'normalizeNbspRuns',
    standalone: true,
})
export class NormalizeNbspRunsPipe implements PipeTransform {

  transform(html: string): string {
    return DomUtils.normalizeNbspRuns(html);
  }

}
